import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { WhitelabelService } from '../whitelabel.service';

@Component({
  selector: 'app-terms-privacy-platform',
  templateUrl: './terms-privacy-platform.component.html',
  styleUrl: './terms-privacy-platform.component.scss',
})
export class TermsPrivacyPlatformComponent implements OnInit {
  @Input() message: string;

  @Input() privacyUrl: string;
  @Input() termsUrl: string;

  constructor(private whitelabelService: WhitelabelService) {}

  ngOnInit(): void {
    this.setupLinks();
  }

  private setupLinks() {
    if (!this.termsUrl) {
      this.termsUrl = this.whitelabelService.getWhiteLabelTermsLink();
    }

    if (!this.privacyUrl) {
      this.privacyUrl = this.whitelabelService.getWhiteLabelPrivacyLink();
    }
  }
}
